export default "__VITE_ASSET__BUG3Quc___"